import { useEffect, useState } from "react";
import { usePageState } from "../../Layout";
import Spacer from "../../components/Spacer";
import List from "../../components/List";
import ProfileEdit from "./ProfileEdit";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import Button from "../../components/Button";

export default function Profile() {
  const { pageState, setPageState } = usePageState();

  const [profileEdit, setProfileEdit] = useState(false);

  const getUserData = async () => {
    var url =
      pageState.userData.user_type === "user"
        ? apiUrl + "users/" + pageState.userData.uuid
        : apiUrl + "customers/" + pageState.userData.uuid;
    await executeRequest(
      url,
      "GET",
      null,
      { Authorization: "Bearer " + getToken() },
      (data) => {
        setPageState((prev) => ({
          ...prev,
          userData: data,
        }));
      },
      (error) => {
        console.log(error);
      }
    );
  };

  if (profileEdit !== false) {
    return (
      <>
        <Button
          text="< Back to profile"
          type="underlined"
          onClicked={() => {
            setProfileEdit(false);
          }}
        />
        <Spacer />
        <ProfileEdit
          onProfileEditted={() => getUserData()}
          profileInfo={pageState.userData}
        />
      </>
    );
  }

  return (
    <div>
      <h1 className="page-title">Profile</h1>
      <Spacer height="10px" />
      {pageState.userData && (
        <List
          headers={["First name", "Last name", "Email", "Phone"]}
          itemType="profile-info"
          items={[
            {
              first_name: pageState.userData.first_name,
              last_name: pageState.userData.last_name,
              email: pageState.userData.email,
              phone: pageState.userData.phone,
            },
          ]}
          isLoading={false}
          onEdit={(item) => {
            setProfileEdit(true);
          }}
        />
      )}
    </div>
  );
}
